export const calculateTotal = (list, column) =>
  list
    .map(item => item[`${column}`])
    .reduce((accumulator, currentValue) => {
      return +accumulator! + +currentValue!;
    }, 0);
